export const progressAnimation = {
  targetPercentage: 90,
  durationInSeconds: 8,
  ease: [0.1, 0.8, 0.3, 1],
  completedPercentage: 100,
  completedDurationInSeconds: 0.4,
}
